import { render, staticRenderFns } from "./InventoryParent.vue?vue&type=template&id=141cc7d7&"
import script from "./InventoryParent.vue?vue&type=script&lang=js&"
export * from "./InventoryParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports